import { escape } from 'lodash-es';

/**
 * Escapes HTML-significant characters so text can be safely inserted into an [innerHTML] binding.
 */
export function escapeHtml(text: string): string {
  return escape(text);
}
